<template>
  <div>
    <Toolbar
      :handle-reset="resetForm"
      :handle-submit="onCreateSubscription"
      :enableSubmit="!blockEditing"
      :enableReset="!blockEditing"
    />
    <SubscriptionForm
      v-if="subscription"
      :errors="violations"
      :values="item"
      ref="updateForm"
      refForm="updateForm"
      :loading="$apollo.queries.subscription.loading"
      :disabled="blockEditing"
    />
    <v-card
      max-width="800px"
      class="mt-4 mx-auto"
    >
      <v-row>
        <v-col cols="12">
          <v-card
            outlined
            tile
          >
            <v-card-text>
              <SubscriberListAndAdd
                v-if="subscription"
                ref="subscriberList"
                :subscription="subscription"
                :locked="blockAddSubscribers"
                @updateSubscribers="updateSubscribersHandler"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <Loading :visible="$apollo.queries.subscription.loading" />
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import SubscriptionForm from '../../components/subscription/Form.vue';
  import SubscriberListAndAdd from '../../components/subscriber/ListAndAdd.vue';
  import Loading from '../../components/Loading';
  import Toolbar from '../../components/Toolbar';

  const servicePrefix = 'Subscription';

  export default {
    name: 'SubscriptionUpdate',
    servicePrefix,
    components: {
      Loading,
      Toolbar,
      SubscriptionForm,
      SubscriberListAndAdd,
    },
    data() {
      return {
        item: {},
        violations: {},
        headers: [
          { text: this.$i18n.t('title'), value: 'title' },
          { text: this.$i18n.t('price'), value: 'price' },
          { text: this.$i18n.t('sortOrder'), value: 'sortOrder' },
          {
            text: this.$i18n.t('Actions'),
            value: 'action',
            sortable: false
          }
        ]
      };
    },
    computed: {
      blockAddSubscribers() {
        return false;
      },
      blockEditing() {
        return this.subscription && this.subscription.subscribers && this.subscription.subscribers.collection.length > 0 || false;
      },
    },
    methods: {
      reloadSubscription() {
        const data = this.$apollo.queries.subscription.refetch();
        return data;
        // return this.retrieve(decodeURIComponent(this.item['@id']));
      },
      onCreateSubscription() {
        if (this.$route.params.parent) {
          this.$refs.createForm.item.parent = this.$route.params.parent;
        }
        this.onSendForm();
      },
      editHandler(item) {
        this.retrieve(item['@id']).then(() => {
          this.$router.push({
            name: `${this.$options.servicePrefix}Update`,
            params: { id: item['@id'] }
          });
        });
      },
      deleteHandler(item) {
        this.deleteItem(item);
      },
      deleteWatcher(deleted) {
        if (!deleted) {
          return;
        }
        this.showMessage(this.deleteMessage);
        this.retrieve(deleted.parent);
      },
      processSubscriptionInvoices() {
        this.$confirm(this.$t('processSubscriptionInvoices'), {
          buttonTrueText: this.$t('Yes'),
          buttonFalseText: this.$t('No'),
        }).then((response) => {
          if (!response) {
            return;
          }
          this.actionSubscription({ item: this.item, action: 'invoiceGenerate' });
        });
      },
      updateSubscribersHandler(updatedSubscribers) {
        this.item.subscribers = updatedSubscribers;
        this.reloadSubscription();
      },
      onSendForm() {
        if (this.isValidForm()) {
          this.updateSubscription(this.$refs.updateForm.$v.item.$model);
        }
      },
      isValidForm() {
        const updateForm = this.$refs.updateForm;
        updateForm.$v.$touch();
        return !updateForm.$v.$invalid;
      },
      resetForm() {
        this.$confirm('Formular zurücksetzen?', {
          buttonTrueText: this.$t('Yes'),
          buttonFalseText: this.$t('No'),
        }).then((response) => {
          if (!response) {
            return;
          }
          this.doResetForm();
        });
      },
      doResetForm() {
        this.$refs.updateForm.$v.$reset();
        this.item = { ...this.subscription };
      },
      updateSubscription(updatedSubscription) {
        const updateSubscriptionInput = {
          ...updatedSubscription,
          ... {
            discounts: updatedSubscription.discounts.collection.map(discount => {
              if (typeof discount === 'string' || discount instanceof String) {
                return discount
              } else {
                return discount.id
              }
            })
          },
          ... {
            seminars: updatedSubscription.seminars.collection.map(seminar => {
              if (typeof seminar === 'string' || seminar instanceof String) {
                return seminar
              } else {
                return seminar.id
              }
            })
          },
          ... {
            topics: updatedSubscription.topics.collection.map(topic => {
              if (typeof topic === 'string' || topic instanceof String) {
                return topic
              } else {
                return topic.id
              }
            })
          },
        };

        delete updateSubscriptionInput.__typename;
        delete updateSubscriptionInput._id;
        delete updateSubscriptionInput.slug;
        delete updateSubscriptionInput.subscribers;

        this.$apollo.mutate({
          mutation: gql`mutation ($input: updateSubscriptionInput!) {
            updateSubscription(input: $input) {
              subscription{
                id
              }
            }
          }`,
          variables: {
            input: updateSubscriptionInput,
          },
          context: {
            headers: {
              authorization: this.$store.state.authentication.loggedIn ? `Bearer ${this.$store.state.authentication.token}` : ''
            }
          }
        }).then(() => {
          // Result
          this.reloadSubscription();
        }).catch((error) => {
          // Error
          console.error(error)
        });
      }
    },
    watch: {
      subscription() {
        this.item = { ...this.subscription };
      }
    },
    beforeRouteUpdate(to, from, next) {
      if (to.params.id !== from.params.id) {
        this.loadObjectToUpdate().then(() => this.doResetForm());
      }
      next();
    },
    fragments: {
      subscriber: gql`
        fragment subscriber on Subscriber {
          id
          _id
          name
          email
          customer{
            id
            customerNumber
            isBusiness
            email
            profile{
              id
              title
              salutation
              firstName
              lastName
              company
            }
          }
          invoice{
            id
            number
            type
            paid
            cancellationInvoice{
              id
            }
            date
            frozen
          }
          createdAt
        }
      `
    },
    apollo: {
      subscription() {
        return {
          query: gql`
            query subscription($id: ID!) {
              subscription(id: $id){
                id
                _id
                name
                slug
                number
                description
                start
                end
                releaseDate
                subscriptionPeriodInMonth
                price
                type
                discounts{
                  collection{
                    id
                  }
                }
                seminars{
                  collection{
                    id
                  }
                }
                topics{
                  collection{
                    id
                  }
                }
                amountPresence
                amountOnline
                subscribers(itemsPerPage: 9999){
                  paginationInfo{
                    totalCount
                  }
                  collection{
                    ...subscriber
                  }
                }

              }
            }
            ${this.$options.fragments.subscriber}
          `,
          variables() {
            return {
              id: this.$route.params.id
            }
          },
          context: {
            headers: {
              authorization: this.$store.state.authentication.loggedIn ? `Bearer ${this.$store.state.authentication.token}` : ''
            }
          }
        }
      },
    },
  };
</script>
